export default "__VITE_ASSET__CH56_iLA__"